export default "__VITE_ASSET__5f297e0f__"